import { render, staticRenderFns } from "./hold-pay-report.vue?vue&type=template&id=68aa3b08&"
import script from "./hold-pay-report.vue?vue&type=script&lang=js&"
export * from "./hold-pay-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports